import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import API_URL from "../../../src/Config";

function EditForm({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const [designationData, setDesignationData] = useState({
    plant_name: "",
    description:"",
  });

  const [error, setError] = useState({});
  const [severity, setSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };
  useEffect(() => {
    const fetchDesignationData = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(`${API_URL}/api/get_amc_plant/${id}`, {
          headers: {
            Authorization: authKey,
          },
        });
  
        const plantData = response.data; // not an array
        console.log("API response:", plantData);
  
        setDesignationData({
          plant_name: plantData.plant_name || "",
          description: plantData.description || "",
        });
  
        console.log("Designation data set:", plantData.plant_name);
        setIsDataLoading(false);
      } catch (error) {
        console.error("Error fetching designation data:", error.message);
        setError("An error occurred while fetching designation data");
        setIsDataLoading(false);
      }
    };
  
    fetchDesignationData();
  }, [id]);
  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDesignationData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
      [name]: "", // Clear the error message for this field
    }));
  };

  const handleCancelClick = () => {
    // navigate("/designations");
    window.history.back();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSaveClick = async () => {
   
    const newErrors = {};

    if (!designationData.plant_name || designationData.plant_name.trim() === "") {
      newErrors.plant_name = "Plant name is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return; // stop submission
    }

    setError({}); // clear errors if any previousl
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await axios.put(
        `${API_URL}/api/update_amc_plant/${id}`,
        designationData,
        {
          headers: {
            Authorization: authKey,
          }
        }
      );

      if (response.status === 200) {
        showSnackbar("Data updated successfully");
        setTimeout(() => {
          navigate("/Plants");
        }, 1000);
      }
    } catch (error) {
      console.error("Error updating designation:", error.message);
      setError("An error occurred while updating designation data");
      setIsLoading(false);
    }
  };

  const handleBackProject = () => {
    navigate("/Plants");
  };

  if (isDataLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div
        className={`data-edit-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBackProject}
                  />
                </Tooltip>
                Edit Plant
              </div>
              <div className="data-edit-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-edit-form-body">
            <form action="" onKeyDown={handleKeyDown}>
              <div className="new-data-edit-form">
                <div className="form-group">
                  <label htmlFor="designation_name">
                    Plant Name<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="plant_name"
                      value={designationData.plant_name}
                      onChange={handleInputChange}
                      placeholder="Enter Plant Name"
                    />
                  </div>
                  {error.plant_name && (
                    <div className="error-message">{error.plant_name}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="designation_name">
                    Description
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="description"
                      value={designationData.description}
                      onChange={handleInputChange}
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-edit-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-edit-form-cancel-button"
                type="button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditForm;
